import { type FC } from "react";
import { AgentResponseBlock_TodoItem_Phase } from "gitpod-next-api/gitpod/v1/agent_pb";
import type { AgentMessageFragmentTodoItem } from "@/hooks/use-stream-conversation";

export const FragmentTodoItem: FC<{
    fragment: AgentMessageFragmentTodoItem;
}> = ({ fragment }) => {
    // Render H2 headers only for started (in-progress) todos to enable navigation
    if (fragment.status === AgentResponseBlock_TodoItem_Phase.IN_PROGRESS) {
        return (
            <div className="mt-4 flex items-center justify-between gap-2">
                <h2
                    id={`todo-${fragment.todoItemId}`}
                    className="text-xl font-semibold tracking-[-0.2px] text-content-primary"
                >
                    {fragment.title}
                </h2>
                <div className="rounded bg-surface-muted px-1.5 py-0.5 text-xs font-medium uppercase tracking-[0.5px] text-content-muted">
                    TODO
                </div>
            </div>
        );
    }

    // Don't render anything for other todo statuses (PENDING, DONE, CLEARED)
    return null;
};
